const Placements = {
    TEASER: 'teaser',
    PRESCREEN: 'prescreen',
    SLIDE_UP: 'slide-up',
    CONTROL_MESSAGE: 'control-message',
    CONTROL_CARD: 'control-card',
};
export default Placements;
//# sourceMappingURL=Placements.js.map